import { createApp } from 'vue';
import couponForm from './couponForm.vue';

const mountEl = document.getElementById('couponForm');
const props = { custom: mountEl?.dataset?.custom ?? '{}' };

createApp(couponForm, props).mount(mountEl || '#couponForm');
